var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaciente(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.14671 71.5553C6.14671 71.5553 0.213379 71.5553 0.213379 65.6403C0.213379 59.7253 6.14671 41.9802 35.8134 41.9802C65.48 41.9802 71.4134 59.7253 71.4134 65.6403C71.4134 71.5553 65.48 71.5553 65.48 71.5553H6.14671ZM35.8134 36.0651C40.5342 36.0651 45.0617 34.1956 48.3999 30.8677C51.738 27.5399 53.6134 23.0263 53.6134 18.32C53.6134 13.6138 51.738 9.10022 48.3999 5.77237C45.0617 2.44452 40.5342 0.574951 35.8134 0.574951C31.0925 0.574951 26.565 2.44452 23.2269 5.77237C19.8887 9.10022 18.0134 13.6138 18.0134 18.32C18.0134 23.0263 19.8887 27.5399 23.2269 30.8677C26.565 34.1956 31.0925 36.0651 35.8134 36.0651Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaciente);
export default __webpack_public_path__ + "static/media/paciente.228db4c06e1406f5551df40aa9ed2794.svg";
export { ForwardRef as ReactComponent };